import {useContext, useState} from 'react';
import axios from 'axios';
import useAuth from "hooks/useAuth";
import {useNavigate, useLocation, useSearchParams} from 'react-router-dom';
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";
import {config} from 'config';
import logo from 'assets/images/LogoWellbeing360.png';
import toast from "react-hot-toast";
import {FormattedMessage} from "react-intl";
import {AppContext} from "../../../contexts/AppContext";


const LoginForm = ({handleCloseModal, eventLive}) => {
    const dataLang = useContext(AppContext)
    const {login, newPasswordChallenge, user} = useAuth();
    const {register, handleSubmit, formState: {errors}} = useForm();
    const [isWaitingForLogin, setIsWaitingForLogin] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const [newPassRequired, setNewPassRequired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [affiliate, setAffiliate] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showTempPassword, setShowTempPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const specialRegister = searchParams.get('specialRegister');

    const onSubmit = async (data) => {
        setIsWaitingForLogin(true);
        setErrorMessage('');
        try {
            const loggedInUser = await login(data.userName, data.password);

            if (specialRegister) {
                try {
                    const userResponse = await axios.get(`${config.api_endpoint}/user/${loggedInUser.sub}`);
                    if (!userResponse.data.special) {
                        navigate('/sign-up?specialRegister=true', { state: { userData: userResponse.data } });
                        handleCloseModal();
                        setIsWaitingForLogin(false);
                        return;
                    }
                } catch (userErr) {
                    console.error("Error fetching user info:", userErr);
                    navigate('/sign-up?specialRegister=true');
                    handleCloseModal();
                    setIsWaitingForLogin(false);
                    return;
                }
            }

            setTimeout(() => {
                if (location.pathname === '/login') {
                    if (eventLive){
                        navigate(`/live/index.html?token=${loggedInUser.session}`);
                    }
                    else{
                        navigate('/');
                    }
                } else {
                    handleCloseModal();
                }
                setIsWaitingForLogin(false);
            }, config.login_modal_wait_time);
        } catch (err) {
            setIsWaitingForLogin(false);
            if (err == 'NotAuthorizedException: Incorrect username or password.') {
                const error_lang = dataLang.langSpanish ? 'Correo o contraseña incorrecta.' : "Invalid email or password"
                setErrorMessage(error_lang);
            }
            if (err == 'NotAuthorizedException: Password attempts exceeded') {
                const error_lang = dataLang.langSpanish ? 'Ha excedido el número de intentos. Espere unos minutos e inténtelo nuevamente.' :
                    "The number of attempts has been displayed, wait a few minutes and try again"
                setErrorMessage(error_lang);
            }
            if (err == "newPasswordRequired") {
                setNewPassRequired(true)
                const message_lang = dataLang.langSpanish ? "Por favor actualiza tu contraseña" : "pleas update your password"
                toast(
                    (t) => (
                        <div className="">
                            <h4 className="pToastLogOut">{message_lang}</h4>
                            <button className="btn button-purple buttonToast" onClick={() => {
                                toast.dismiss(t.id);
                            }}>Ok
                            </button>
                        </div>
                    ), {duration: 5000,}
                );
            }
        }
    }

    const chalengeNewPassword = async (data) => {
        setIsWaiting(true);
        setErrorMessage('');
        try {
            const loggedInUser = await newPasswordChallenge(data.userName, data.password, data.newPassword);

            if (specialRegister) {
                try {
                    const userResponse = await axios.get(`${config.api_endpoint}/user/${loggedInUser.sub}`);
                    if (!userResponse.data.special) {
                        navigate('/sign-up?specialRegister=true', { state: { userData: userResponse.data } });
                        handleCloseModal();
                        setIsWaiting(false);
                        return;
                    }
                } catch (userErr) {
                    console.error("Error fetching user info:", userErr);
                    navigate('/sign-up?specialRegister=true');
                    handleCloseModal();
                    setIsWaiting(false);
                    return;
                }
            }

            setTimeout(() => {
                setIsWaiting(false);
                const message_lang = dataLang.langSpanish ? 'Contraseña actualizada' :
                    "Your password was updated"
                if (location.pathname === '/login') {
                    toast(
                        (t) => (
                            <div className="">
                                <h4 className="pToastLogOut" >{message_lang}</h4>
                                <button className="btn button-purple buttonToast" onClick={() => {
                                    navigate(`/`)
                                    toast.dismiss(t.id);
                                }}>Ok</button>
                            </div>
                        ), {duration: 20000,}
                    );
                } else {
                    handleCloseModal();
                }
                setIsWaitingForLogin(false);
            }, config.login_modal_wait_time);
        } catch (err) {
            console.log(err)

            setIsWaiting(false);
            if (err == 'NotAuthorizedException: Incorrect username or password.') {
                const error_lang = dataLang.langSpanish ? 'Correo o contraseña incorrecta.' : "Invalid email or password"
                setErrorMessage(error_lang);
            }
            if (err == 'NotAuthorizedException: Password attempts exceeded') {
                const error_lang = dataLang.langSpanish ? 'Ha excedido el número de intentos. Espere unos minutos e inténtelo nuevamente.' :
                    "The number of attempts has been displayed, wait a few minutes and try again"
                setErrorMessage(error_lang);
            }
        }
    }

    const LoginForm = () => {
        return (
            <>
                <form name="pms_login" id="pms_login" className="colorBlack" autoComplete="off"
                      onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-9">
                            <h4><FormattedMessage
                                id="loginTitle"
                                defaultMessage="INICIAR SESIÓN"
                            /></h4>
                        </div>

                        <div className="col-md-3">
                            <Link to={'/'} className="navbar-brand">
                                <img src={logo} alt="Wellbeing 360" className="img-fluid logo"/>
                            </Link>
                        </div>
                    </div>
                    <div className="login-username">
                        <label>
                            <FormattedMessage
                                id="loginEmail"
                                defaultMessage="Correo electrónico"
                            /></label>
                        <input
                            {...register("userName", {required: true})}
                            type="text"
                            id="user_login"
                            className="input"
                            defaultValue=""
                            size="20"/>
                        {errors?.userName?.type === "required" && <span className="form-error">
                            <FormattedMessage
                                id="loginRequiredCamp"
                                defaultMessage="Campo requerido"
                            /></span>}
                    </div>
                    <div className="login-password">
                        <label><FormattedMessage
                            id="loginPassword"
                            defaultMessage="Contraseña"
                        /></label>
                        <div className="password-input-wrapper">
                            <input
                                {...register("password", {required: true})}
                                type={showPassword ? "text" : "password"}
                                id="user_pass"
                                className="input"
                                defaultValue=""
                                size="20"/>
                            <i 
                                className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle-icon`}
                                onClick={() => setShowPassword(!showPassword)}
                            />
                        </div>
                        {errors?.password?.type === "required" && <span className="form-error">
                            <FormattedMessage
                            id="loginRequiredCamp"
                            defaultMessage="Campo requerido"
                        /></span>}
                    </div>
                    {errorMessage ? (
                        <div className="login-error">
                            {errorMessage}
                        </div>
                    ) : <></>
                    }
                    <div className="login-submit">
                        {isWaitingForLogin ? (
                            <div className="spinner-border text-light" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        ) : (
                            <input type="submit" name="wp-submit" id="wp-submit" className="button button-primary"
                                   value="Log In"/>
                        )
                        }
                    </div>
                    <p>
                        <input type="hidden" name="pms_login" value="1"/><input type="hidden" name="pms_redirect"/>
                        <Link
                            to={specialRegister ? "/sign-up?specialRegister=true" : "/sign-up"}
                            onClick={handleCloseModal}>
                            <FormattedMessage
                                id="subscribeLow"
                                defaultMessage="Suscríbete"
                            />
                        </Link> |
                        <Link to="/recovery-pass" onClick={handleCloseModal}>
                            <FormattedMessage
                                id="loginForgotPassword"
                                defaultMessage=" ¿Olvidaste tu contraseña?"
                            />
                        </Link>
                    </p>
                </form>
            </>
        )
    }

    const NewPass = () => {
        return (
            <>
                <form name="pms_login" id="pms_login" className="colorBlack" autoComplete="off"
                      onSubmit={handleSubmit(chalengeNewPassword)}>
                    <div className="row">
                        <div className="col-md-9">
                            <h4><FormattedMessage
                                id="loginUpdateTitle"
                                defaultMessage="ACTUALIZAR CONTRSEÑA"
                            /></h4>
                        </div>

                        <div className="col-md-3">
                            <Link to={'/'} className="navbar-brand">
                                <img src={logo} alt="Wellbeing 360" className="img-fluid logo"/>
                            </Link>
                        </div>
                    </div>
                    <div className="login-username">
                        <label><FormattedMessage
                            id="loginEmail"
                            defaultMessage="Correo electrónico"
                        /></label>
                        <input
                            {...register("userName", {required: true})}
                            type="text"
                            id="user_login"
                            className="input"
                            defaultValue=""
                            size="20"/>
                        {errors?.userName?.type === "required" && <span className="form-error"><FormattedMessage
                            id="loginRequiredCamp"
                            defaultMessage="Campo requerido"
                        /></span>}
                    </div>
                    <div className="login-password">
                        <label><FormattedMessage
                            id="loginPassword"
                            defaultMessage="Contraseña"
                        /></label>
                        <div className="password-input-wrapper">
                            <input
                                {...register("password", {required: true})}
                                type={showTempPassword ? "text" : "password"}
                                id="user_new_pass"
                                className="input"
                                defaultValue=""
                                size="20"/>
                            <i 
                                className={`fa ${showTempPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle-icon`}
                                onClick={() => setShowTempPassword(!showTempPassword)}
                            />
                        </div>
                        {errors?.password?.type === "required" && <span className="form-error"><FormattedMessage
                            id="loginRequiredCamp"
                            defaultMessage="Campo requerido"
                        /></span>}
                    </div>
                    <div className="login-password">
                        <label><FormattedMessage
                            id="loginNewPassword"
                            defaultMessage="Nueva Contraseña"
                        /></label>
                        <div className="password-input-wrapper">
                            <input
                                {...register("newPassword", {required: true})}
                                type={showNewPassword ? "text" : "password"}
                                id="user_pass"
                                className="input"
                                defaultValue=""
                                size="20"/>
                            <i 
                                className={`fa ${showNewPassword ? 'fa-eye-slash' : 'fa-eye'} password-toggle-icon`}
                                onClick={() => setShowNewPassword(!showNewPassword)}
                            />
                        </div>
                        {errors?.password?.type === "required" && <span className="form-error"><FormattedMessage
                            id="loginRequiredCamp"
                            defaultMessage="Campo requerido"
                        /></span>}
                    </div>
                    {errorMessage ? (
                        <div className="login-error">
                            {errorMessage}
                        </div>
                    ) : <></>
                    }
                    <div className="login-submit">
                        {isWaiting ? (
                            <div className="spinner-border text-light" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        ) : (
                            <input type="submit" name="wp-submit" id="wp-submit" className="button button-primary"
                                   value={ dataLang.langSpanish ? "Actualizar" : "Update"}/>
                        )
                        }
                    </div>
                </form>
            </>
        )
    }

    return (
        <>
            {newPassRequired ? (<NewPass/>) : (<LoginForm/>)}
        </>
    )
}

export default LoginForm;
